<!-- 富文本组件 -->
<template>
    <div>
        <Upload
            class="quill-upload display-none"
            ref="upload"
            :show-upload-list="false"
            :format="[
                'jpg',
                'jpeg',
                'png',
                'gif',
                'mp4',
                'avi',
                'mov',
                'pdf',
                'xls',
                'xlsx',
                'doc',
                'docx',
            ]"
            :max-size="51200"
            :on-exceeded-size="exceededSize"
            :on-format-error="handleFormatError"
            :on-success="handleUploadSuccess"
            :headers="headers"
            :action="uploadImg"
        >
            <i class="el-icon-upload"></i>
        </Upload>

        <quill-editor
            :disabled="disabled"
            ref="myQuillEditor"
            class="myQuillEditor"
            v-model="editorData"
            :options="editorOption"
            @change="onEditorChange"
        ></quill-editor>
    </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { getCookies } from "@/utils/helper";
import config from "@/config/index";

export default {
    name: "editors",
    components: { quillEditor },
    props: {
        edtorCon: {
            type: String,
            default: "",
        },
        index: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        disUpload: {
            type: Number,
            default: 0,
        },
    },
    data() {
        // 保留原有全部功能 + 删除重复项 + 完善功能
        const toolbarOptions = [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ["link"],
            ["clean"],
            ["image"],
        ];

        return {
            editorOption: {
                placeholder: "请输入内容",
                modules: {
                    toolbar: {
                        container: toolbarOptions,
                        handlers: {
                            image: () => this.openUpload(),
                        },
                    },
                },
            },
            uploadImg: config.apiUrl.replace(/\/+$/, "") + "/api/other/upload",
            headers: { "hlzw-suyuan-token": getCookies("pcToken") },
            editorData: "",
        };
    },
    created() {
        if (this.disUpload === 1) {
            this.editorOption.modules.toolbar.container =
                this.editorOption.modules.toolbar.container.filter((item) => {
                    if (Array.isArray(item)) {
                        return !item.some(
                            (s) =>
                                typeof s === "string" &&
                                ["image", "video"].includes(s)
                        );
                    }
                    return true;
                });
        }
    },
    methods: {
        // 打开上传
        openUpload() {
            const uploadEl = this.$refs.upload;
            if (uploadEl && uploadEl.$el) {
                const btn = uploadEl.$el.querySelector(
                    ".el-icon-upload, .ivu-icon-ios-cloud-upload-outline"
                );
                if (btn) btn.click();
            }
        },

        // 上传成功（自动区分：图片 / 视频 / 文件）
        handleUploadSuccess(res, file) {
            if (res.code !== 200 || !res.data?.path) return;

            const quill = this.$refs.myQuillEditor.quill;
            const idx = quill.getSelection()?.index ?? quill.getLength();
            const url = res.data.path;
            const ext = this.getFileExt(url);
            const realName = file?.name || "文件";

            // 图片
            if (["jpg", "jpeg", "png", "gif"].includes(ext)) {
                quill.insertEmbed(idx, "image", url);
            }
            // 视频
            else if (["mp4", "avi", "mov"].includes(ext)) {
                quill.insertEmbed(idx, "video", url);
            }
            // 文件（PDF/Word/Excel）
            else {
                const safeName = realName
                    .replace(/&/g, "&amp;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;")
                    .replace(/"/g, "&quot;")
                    .replace(/'/g, "&#039;");
                const safeUrl = url.replace(/"/g, "&quot;");
                const link = `<a href="${safeUrl}" target="_blank" style="color:blue;text-decoration:underline;">${safeName}</a>`;
                quill.clipboard.dangerouslyPasteHTML(idx, link);
            }

            quill.setSelection(idx + 1);
        },

        // 获取文件后缀
        getFileExt(url) {
            const cleanUrl = url.split("?")[0].split("#")[0];
            const parts = cleanUrl.split(".");
            return parts.length > 1
                ? parts[parts.length - 1].toLowerCase()
                : "";
        },

        // 内容变化
        onEditorChange() {
            this.$emit("getContent", {
                editorData: this.editorData,
                index: this.index,
            });
        },

        // 提示
        exceededSize() {
            this.$Message.warning("文件大小限制在50MB以内");
        },
        handleFormatError() {
            this.$Message.warning("暂不支持上传此格式");
        },
    },
    watch: {
        edtorCon: {
            handler(val) {
                this.editorData = val || "";
            },
            immediate: true,
        },
    },
};
</script>

<style scoped>
::v-deep .ql-editor {
    min-height: 333px;
}
::v-deep .ql-toolbar.ql-snow {
    border-bottom: 1px solid #aaaaaa;
}
::v-deep .ql-snow .ql-picker-options .ql-picker-item {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    line-height: 25px !important;
}
.display-none {
    display: none !important;
}
</style>